import gql from 'graphql-tag';

export const verifyAndSubmitServiceRequestChargeMutation = gql(`
  mutation verifyAndSubmitServiceRequestChargeMutation(
    $input: VerifyAndSubmitServiceRequestChargeInput!
  ) {
    verifyAndSubmitServiceRequestCharge(input: $input) {
      chargeId
      serviceRequestId
      chargeVerificationStatus
    }
  }
`);
